"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helpStorage = require("@ua/help-storage");

var _constants = require("../../constants");

var _default = function _default(store) {
  return function (apply) {
    return function (action) {
      var result = apply(action);
      var nextStateToPersist = store.getState();
      (0, _helpStorage.setItem)(_constants.LOCALSTORAGE_KEY_STORE_EXPIRES, Date.now());
      (0, _helpStorage.setItem)(_constants.LOCALSTORAGE_KEY_STORE, JSON.stringify(nextStateToPersist));
      return result;
    };
  };
};

exports["default"] = _default;